// TODO: This file belongs in app, not common.

import { DialogType } from '@tableau/widgets';

import { AboutTableauServerDialog } from '../../app/header/AboutTableauServerDialog';
import { ModalInstance, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import { HelpService } from '../../commonInfra/services/HelpService';
import { SessionManagementService } from '../../sessionManagement/SessionManagementService';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';

export class HelpActions {

  constructor(
    private server: SessionManagementService,
  ) {}

  public showAbout() {
    let modalInstance: ModalInstance;

    const dialogProps = {
      dismiss: () => modalInstance && modalInstance.dismiss(),
      serverName: ServerSettingsUnauthenticated.serverName(),
      version: this.server.sessionServerVersion(),
      podId: this.server.sessionServerPodId()
    };

    modalInstance = ReactModalService.open({
      type: DialogType.NormalWithTitleBar,
      title: AboutTableauServerDialog.Title(dialogProps),
      dialogContent: AboutTableauServerDialog.Content(dialogProps),
      footerContent: AboutTableauServerDialog.Footer(dialogProps),
      dialogWidth: 450
    });
  }

  public searchHelp(searchTerm: string) {
    HelpService.search(searchTerm);
  }

}
